
import React from 'react';
import {
  Form, Icon, Input, Button, Checkbox,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faGlobe, faLockAlt } from '@fortawesome/pro-light-svg-icons';
import storage from 'redux-persist/lib/storage';
import { StoreContext } from '../../../StoreContext';
import { persistConfig } from '../../../index';


const DEVELOP_DOMAINS = ['preimp', 'cli', 'precli', 'prelatam', 'preimplatam', 'latam', 'implatam', 'aao', 'imporacle'];
class NormalLoginForm extends React.Component {

  static contextType = StoreContext;
  domain = window.location.href.match(/https:\/\/(.*)-gioweb2/);
  isDevelopDomain = this.domain ? DEVELOP_DOMAINS.includes(this.domain[1]) : true;

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
         this.props.onSubmit(this.isDevelopDomain ? values : {...values, dominio: this.domain[1] + '-gioweb'});
      }
    });
  };

  render() {
    const { changeStoreConfig } = this.context;
    const { getFieldDecorator } = this.props.form;
    const { loading, history } = this.props;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: 'Please input your username!' }],
          })(
            <Input
              size="large"
              readOnly={loading}
              prefix={<FontAwesomeIcon icon={faUser} color="#918E87" />}
              placeholder="Usuario"
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              size="large"
              readOnly={loading}
              prefix={<FontAwesomeIcon icon={faLockAlt} color="#918E87" />}
              type="password"
              placeholder="Contraseña"
            />,
          )}
        </Form.Item>
        {this.isDevelopDomain &&
        <Form.Item>
          {getFieldDecorator('dominio', {
            rules: [{ required: true, message: 'Please input your dominio!' }],
          })(
            <Input
              size="large"
              readOnly={loading}
              prefix={<FontAwesomeIcon icon={faGlobe} color="#918E87" />}
              placeholder="Dominio"
            />,
          )}
        </Form.Item>
        }
        <Form.Item>
          <Button size="large" block loading={loading} type="primary" htmlType="submit" className="login-form-button">
            Entrar
          </Button>
        </Form.Item>
        <Form.Item>
          <div className="bottomLogin">
            <Checkbox
              defaultChecked
              onChange={e => changeStoreConfig(e.target.checked ? persistConfig : { ...persistConfig, whitelist: [] })}
            >
              Recuérdame
            </Checkbox>
            <a onClick={() => history.push('/login/recuperar')} className="forgetLink">Olvidé mi contraseña</a>
          </div>
        </Form.Item>
      </Form>
    );
  }
}

const LoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);
export default LoginForm;
